import { useMutation } from 'react-query';
import { httpService } from '../../../../../services/http.service';
import { BASE_URL } from '../../../../../constants/endpoints';

interface IProps {
    customerId: string;
    recipientId: string;
}

export const useDeleteRecipient = () => useMutation(
  'useDeleteProduct',
  async ({
    customerId, recipientId,
  }: IProps) => {
    const res = await httpService.delete(`${BASE_URL}/api/v1/user/${customerId}/recipient/${recipientId}`);
    return res.data;
  },
  { retry: 0 },
);
